const getToggledClassName = isToggled => {
  return isToggled
    ? '!text-[#5acce6]'
    : '!text-common-bright hover:!bg-[#333333] hover:text-primary-light';
};

export { getToggledClassName };
